import React, { useEffect } from "react";
import "../styles/eventInfo.css";

function EventInfo() {
	//for scroll animation effects
	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const element = entry.target;
				if (entry.isIntersecting) {
					element.classList.add("show");
				} else {
					element.classList.remove("show");
				}
			});
		});
		const hiddenElements = document.querySelectorAll(".hidden");
		//add each element to be observed
		hiddenElements.forEach((element) => {
			observer.observe(element);
		});
	});

	return (
		<div className="info-scroll-box">
			<div className="info-main">
				<div className="info-title hidden">Event Information</div>
				<div className="info-content">
					<div className="info-content-left">
						<div className="left-title hidden">Encode Justice?</div>
						<p className="hidden">
							Encode Justice is a youth-led organization that fights for AI regulation and ethics.
						</p>
						<div className="left-title hidden">EJ WA Hackathon?</div>
						<p className="hidden">
							The Encode Justice Washington Hackathon is an exciting 15-day event that provides a platform
							for students to collaborate and showcase their skills. Participants will work together to
							design and implement a project of social value in one of the following areas in teams of 1-4
							people.
							<br />
							<br />
							Opportunity to win prizes!
						</p>
						{/* <div className="left-title hidden">Prizes</div>
						<p className="hidden">
							1st Place: $200
							<br />
							2nd Place: $100
							<br />
							3rd Place: $50
						</p> */}
					</div>
					<div className="info-content-right">
						<div className="right-title hidden">Areas</div>
						<div className="terms-section">
							<div className="term hidden">
								<def className="term-title">Education</def>
								<div className="term-def">
									Participants will help to advance educational technology for learners of all ages
								</div>
							</div>
							{/* <div className="term hidden">
								<def className="term-title">Personalized Learning</def>
								<div className="term-def">
									Developing technology that adapts to individual student needs and learning styles
								</div>
							</div> */}
							{/* <div className="term hidden">
								<def className="term-title">Accessibility and Inclusion</def>
								<div className="term-def">
									Creating solutions to improve education access and equity for students with
									disabilities and in under-resourced communities
								</div>
							</div> */}
							{/* <div className="term hidden">
								<def className="term-title">EdTech Tools</def>
								<div className="term-def">
									Developing new and innovative EdTech tools to support teachers and students in the
									classroom
								</div>
							</div> */}
							{/* <div className="term hidden">
								<def className="term-title">Career Readiness</def>
								<div className="term-def">
									Creating solutions to help students acquire the skills and knowledge needed for the
									21st-century workforce
								</div>
							</div> */}
							{/* <div className="term hidden">
								<def className="term-title">Sustainability</def>
								<div className="term-def">
									Promoting environmental awareness and sustainability in education
								</div>
							</div> */}
							<div className="term hidden">
								<def className="term-title">Healthcare</def>
								<div className="term-def">
									Participants will tackle real-world healthcare challenges by creating innovative
									solutions using technology
								</div>
							</div>
							<div className="term hidden term-last">
								<def className="term-title">Environment</def>
								<div className="term-def">
									Participants will create innovative solutions to some of the biggest environmental
									challenges facing our planet today
								</div>
							</div>

							<div className="tip hidden">
								Projects that make use of Artificial Intelligence are promoted!
								{/* Bonus Points for making a project related to Artificial Intelligence! */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EventInfo;
